import { useQuery } from '@tanstack/react-query';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';

export type HeatmapCell = {
  weekday: number;
  hour: number;
  count: number;
};

// eslint-disable-next-line import/prefer-default-export
export function useNoteHeatmap(queryParams: string) {
  return useQuery<HeatmapCell[]>({
    queryKey: [APIKey.NOTE_HEATMAP, queryParams],
    queryFn: () => baseFetcher(`${apiRoutes.noteHeatmap()}?${queryParams}`),
  });
}
